import styled from 'styled-components';

export const _Button = styled.button`
  display: block;
  width: ${(props) => (props.fullwidth ? '100%' : 'fit-content')};
  padding: 10px 25px;
  color: ${(props) => props.theme.white};
  font-family: ${(props) => props.theme.fontFamilyPrimary};
  font-size: 24px;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-transform: ${(props) => props.theme.headingTransform};
  background-color: ${(props) => props.theme.primary};
  border: 1px solid ${(props) => props.theme.primary};
  border-radius: 0;

  &:hover {
    background-color: ${(props) => props.theme.hoverPrimary};
    border: 1px solid ${(props) => props.theme.hoverPrimary};
    cursor: pointer;
  }

  &:disabled {
    background-color: ${(props) => props.theme.grey};
    border: 1px solid ${(props) => props.theme.grey};

    &:hover {
      background-color: ${(props) => props.theme.grey};
      cursor: default;
    }
  }
`;
